import {Flex} from "@chakra-ui/react";

function CategoryContainer({children}) {
    return (
        <Flex direction='column' pb={4}>
            {children}
        </Flex>
    )
}

export default CategoryContainer